import Vue from 'vue';
import Auth from '@/api/auth';

export default {
	state: {
		token: null,
		username: null,
	},

	mutations: {
		setToken(state, token) {
			state.token = token;
			localStorage.setItem('token', token);
			Vue.http.headers.common['X-Authorization'] = token;
		},
		setUsername(state, username) {
			state.username = username;
			localStorage.setItem('username', username);
		},
		resetToken(state) {
			state.token = null;
			localStorage.removeItem('token');
			delete Vue.http.headers.common['X-Authorization'];
		},
	},

	actions: {
		updateToken({ commit }, token) {
			commit('setToken', token);
		},
		login({ commit }, credentials) {
			return new Promise((resolve, reject) => {
				Auth.login(credentials)
				.then((data) => {
					commit('setToken', data.jwt);
					commit('setUsername', data.PKM_Nutzername);
					resolve();
				})
				.catch((response) => {
					reject(response);
				});
			});
		},
		logout({ commit }) {
			commit('resetToken');
		},
		userInitialize({ commit }) {
			return new Promise((resolve, reject) => {
				const token = localStorage.getItem('token');
				const username = localStorage.getItem('username');

				if (token && username) {
					commit('setToken', token);
					commit('setUsername', username);
					resolve();
				} else {
					reject();
				}
			});
		},
	},

	getters: {
		getToken(state) {
			return state.token;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js